/* global System */
// register component(s) with react habitat

export default { WorkflowSlider: () => System.import('./data') }
